/**
 * @param item the object that you are checking
 * @param array the list of strings that are required
 * @return undefined if there are no missing fields, otherwise return a message
 * stating what fields are missing.
 */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export default function(
  item: Record<string, any>,
  array: Array<string>
): string | undefined {
  const missing = array.reduce((accum: Array<string>, value: string) => {
    if (!item[value]) {
      accum.push(value);
    }
    return accum;
  }, []);
  if (missing.length == 0) {
    return;
  }
  let missingFields = missing.join("', '");
  if (missing.length == 2) {
    missingFields = missingFields.replace(', ', ' and ');
  } else if (missing.length > 2) {
    const last = missing[missing.length - 1];
    missingFields = missingFields.replace(`, '${last}`, `, and '${last}`);
  }
  const was = missing.length > 1 ? 'were' : 'was';
  const s = missing.length > 1 ? 's' : '';
  return `Required field${s} '${missingFields}' ${was} not found`;
}
